export default "__VITE_ASSET__CnnCGUEs__"